import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="w-full py-16 px-4" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid md:grid-cols-2 gap-8 items-center" data-id="element-149">
          {/* Left: Product Image */}
          <div className="bg-cream-card p-8 rounded-2xl shadow-lg border border-brown/10" data-id="element-150">
            <img src="https://cdn.magicpatterns.com/uploads/iMMm2eRVVXTnnh8ZoN4Mr7/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung mit natürlichen Zutaten" className="w-full rounded-xl object-contain" data-id="element-151" />
          </div>

          {/* Right: Text */}
          <div data-id="element-152">
            <h3 className="font-handwriting text-3xl md:text-4xl text-forest font-bold mb-4" data-id="element-153">
              Was ich bestellt habe
            </h3>
            <div className="font-serif text-lg text-gray-700 space-y-4" data-id="element-154">
              <p data-id="element-155">
                Ich habe mich für das{' '}
                <strong data-id="element-156">Futtertopping Magen & Darm von Hunderunde</strong>{' '}
                entschieden, weil es speziell für träge Verdauung entwickelt
                wurde.
              </p>
              <p data-id="element-157">
                Anders als andere Produkte kombiniert es lösliche und unlösliche
                Ballaststoffe – genau das, was Finns Darm brauchte, um wieder in
                Schwung zu kommen.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}